/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerGetPermissionsQueryResponse, UserControllerGetPermissionsPathParams, UserControllerGetPermissions401, UserControllerGetPermissions403 } from "../../models/usersController/UserControllerGetPermissions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { userControllerGetPermissions } from "../../clients/usersService/userControllerGetPermissions";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const userControllerGetPermissionsQueryKey = (userId: UserControllerGetPermissionsPathParams["userId"]) => [{
  url: '/api/v1/users/:userId/permissions',
  params: {
    userId: userId
  }
}] as const;
export type UserControllerGetPermissionsQueryKey = ReturnType<typeof userControllerGetPermissionsQueryKey>;
export function userControllerGetPermissionsQueryOptions(userId: UserControllerGetPermissionsPathParams["userId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = userControllerGetPermissionsQueryKey(userId);
  return queryOptions<UserControllerGetPermissionsQueryResponse, ResponseErrorConfig<UserControllerGetPermissions401 | UserControllerGetPermissions403>, UserControllerGetPermissionsQueryResponse, typeof queryKey>({
    enabled: !!userId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return userControllerGetPermissions(userId, config);
    }
  });
}

/**
 * @summary Get user scope permissions
 * {@link /api/v1/users/:userId/permissions}
 */
export function useUserControllerGetPermissions<TData = UserControllerGetPermissionsQueryResponse, TQueryData = UserControllerGetPermissionsQueryResponse, TQueryKey extends QueryKey = UserControllerGetPermissionsQueryKey>(userId: UserControllerGetPermissionsPathParams["userId"], options: {
  query?: Partial<QueryObserverOptions<UserControllerGetPermissionsQueryResponse, ResponseErrorConfig<UserControllerGetPermissions401 | UserControllerGetPermissions403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? userControllerGetPermissionsQueryKey(userId);
  const query = useQuery({
    ...userControllerGetPermissionsQueryOptions(userId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UserControllerGetPermissions401 | UserControllerGetPermissions403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}